// extracted by mini-css-extract-plugin
export var currentStep = "_g6-2";
export var nodeCard = "_g6-0";
export var pathHighlighted = "_g6-1";